import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

const LoadingScreen = () => {
  // Définition de l'animation de rebondissement zoom/dezoom
  const animationStyles = `
    @keyframes bounceZoom {
      0%, 100% {
        transform: scale(1);
      }
      25% {
        transform: scale(1.40);
      }
      50% {
        transform: scale(0.70);
      }
      75% {
        transform: scale(1.60);
      }
    }
  `;

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: animationStyles }} />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          width: '100vw',
        }}
      >
        {/* Définition du dégradé SVG invisible mais référençable */}
        <svg width={0} height={0}>
          <defs>
            <linearGradient id="green_gradient" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="#60D744" />
              <stop offset="100%" stopColor="#ccf5c0" /> {/* Un vert plus clair pour l'effet dégradé */}
            </linearGradient>
          </defs>
        </svg>

        {/* Conteneur relatif pour superposer le loader et l'image avec animation */}
        <Box 
          sx={{ 
            position: 'relative', 
            display: 'inline-flex', 
            mb: 3,
            animation: 'bounceZoom 2.5s ease-in-out infinite',
          }}
        >
        <CircularProgress
          size="6rem" 
          thickness={4} 
          sx={{ 'svg circle': { stroke: 'url(#green_gradient)' } }} // Application du dégradé
        />
        <Box
          sx={{
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            position: 'absolute',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <img 
            src="/Aifel.svg" 
            alt="Logo" 
            style={{ 
              width: '40px', 
              height: 'auto' 
            }} 
          />
        </Box>
      </Box>
      
        <Typography 
          variant="h6" 
          sx={{ 
            color: '#2C3E50', 
            fontWeight: 600,
            fontFamily: 'sans-serif'
          }}
        >
          Chargement en cours
        </Typography>
      </Box>
    </>
  );
};

export default LoadingScreen;
